<template>
    <div v-if="show">
        <h2 class="title is-2 section-header">
            Delete all invalid codes from a codeset
        </h2>
        <div class="block">
            <b-field label="CodeSet Name">
                <b-input v-model="codeSetName" />
            </b-field>
            <b-field>
                <b-switch v-model="dryRun">
                    Dry run (rollback transaction)
                </b-switch>
            </b-field>
        </div>
        <div class="buttons">
            <b-button
                type="is-primary"
                :disabled="!enabled"
                @click="run()">
                Run
            </b-button>
            <b-button
                :disabled="!enabled"
                @click="cancelCommand()">
                Cancel
            </b-button>
        </div>
        <div
            v-if="enabled && showReferringCodes && success"
            class="mt-5">
            <h2 class="title is-5">
                Unlinked referring items
            </h2>
            <ref-codes-for-code-set
                :code-set-name="codeSetName" />
        </div>
    </div>
</template>

<script>
    import RefCodesForCodeSet from './RefCodesForCodeSet.vue';
    import runMixin from './RunMixin.js';

    export default {
        components: { RefCodesForCodeSet },
        mixins: [runMixin],
        props: {
            success: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                codeSetName: '',
                dryRun: true,
                showReferringCodes: false
            };
        },
        methods: {
            async run() {
                await this.submitCommand([
                    'delete-invalid-codeset-codes',
                    this.codeSetName,
                    this.dryRun ? 'dry-run' : ''
                ]);
                this.showReferringCodes = this.dryRun;
            }
        }
    };
</script>
